module.exports = "/* You can add global styles to this file, and also import other style files */\nhtml{\n  width: 90%;\n  margin: 0 auto;\n}\nspan.legenda {\n  display: block;\n  font-size: 8pt;\n  font-weight: bold;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles